export default __webpack_public_path__ + "static/media/11.c26e8c70.jpg";